"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreantFormEffectHandler = exports.TreantFormEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class TreantFormEffectArgs {
    constructor(attributeIncrease, healingPercentIncrease) {
        this.attributeIncrease = attributeIncrease;
        this.healingPercentIncrease = healingPercentIncrease;
        this.__type = EffectType_1.EffectType.TreantForm;
        this.__typeName = "TreantForm";
        this.name = "Treant Form";
        this.harmful = false;
    }
}
exports.TreantFormEffectArgs = TreantFormEffectArgs;
let TreantFormEffectHandler = class TreantFormEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyBuffs({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effects: [
                {
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Focus, state.args.attributeIncrease),
                    duration: Duration_1.Duration.Permanent,
                },
                {
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Will, state.args.attributeIncrease),
                    duration: Duration_1.Duration.Permanent,
                },
                {
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.PercentHealingIncrease, state.args.healingPercentIncrease),
                    duration: Duration_1.Duration.Permanent,
                }
            ],
        });
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.TurnEnded, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_TreantForm_OnTurnEnded", {}));
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of state.meta.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
TreantFormEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.TreantForm)
], TreantFormEffectHandler);
exports.TreantFormEffectHandler = TreantFormEffectHandler;
